import { Controller } from "@hotwired/stimulus"

// Handles tier card selection in the event creation upgrade prompt.
export default class extends Controller {
  static targets = ["plusCard", "proCard", "plusRadio", "proRadio", "ctaButton", "ctaText"]
  static values = { selectedTier: String, eventId: Number }

  selectPlus() {
    this.selectedTierValue = "plus"
    this.updateUI()
  }

  selectPro() {
    this.selectedTierValue = "pro"
    this.updateUI()
  }

  updateUI() {
    const isPlus = this.selectedTierValue === "plus"
    const isPro = this.selectedTierValue === "pro"

    this.setCardState(this.plusCardTarget, this.plusRadioTarget, isPlus)
    this.setCardState(this.proCardTarget, this.proRadioTarget, isPro)

    if (isPlus) {
      this.ctaTextTarget.textContent = "Continue with Plus — ₱499"
    } else if (isPro) {
      this.ctaTextTarget.textContent = "Continue with Pro — ₱1,299"
    }

    this.ctaButtonTarget.disabled = false
    this.ctaButtonTarget.classList.remove("bg-gray-300", "opacity-60", "cursor-not-allowed")
    this.ctaButtonTarget.style.background = "linear-gradient(to right, #16707B, #0f5a64)"
  }

  setCardState(card, radio, selected) {
    if (selected) {
      card.classList.remove("border-gray-200")
      card.classList.add("border-teal-600", "bg-teal-50")
      radio.classList.remove("border-gray-300")
      radio.classList.add("border-teal-600", "bg-teal-600")
      radio.innerHTML = '<div class="w-2 h-2 rounded-full bg-white"></div>'
    } else {
      card.classList.add("border-gray-200")
      card.classList.remove("border-teal-600", "bg-teal-50")
      radio.classList.add("border-gray-300")
      radio.classList.remove("border-teal-600", "bg-teal-600")
      radio.innerHTML = ""
    }
  }

  submit() {
    if (!this.selectedTierValue) return

    const eventId = this.eventIdValue
    const tier = this.selectedTierValue

    window.location.href = `/events/${eventId}/upgrade/${tier}`
  }
}
